/**
 * Generischer Stub für noch nicht implementierte Seiten.
 * Wird in Folge-Sitzungen durch echte Pages ersetzt.
 */

export function StubPage({ title, planned }: { title: string; planned: string }) {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <div className="rounded-lg border bg-card p-6 text-sm text-muted-foreground">
        <p>Diese Seite ist noch nicht implementiert.</p>
        <p className="mt-2">Geplant: {planned}</p>
      </div>
    </div>
  );
}
